export default "__VITE_ASSET__DuIzrlGD__"